import { useEffect, useState } from "react";
import CheckBox from "./CheckBox/CheckBox";
import stl from "./CheckBoxGroup.module.css";
import { CDN_LINK } from "@globalConfig";
import {useTranslation} from "@i18n";

const CheckBoxGroup = ({
  options,
  onChange,
  name,
  searchable,
  isColor,
  hasSubGroups,
  isBoldGropuTitle,
  isColorFilter,
  carshape,
  fieldName,
  selectedOptions,
  filterType,
  handleCloseFilter,
  tempSelectedOptions,
  openedFilter,
  filter,
}) => {
  const {t} = useTranslation();
  const [searchValue, setSearchValue] = useState("");

  const filteredOptions = () => {
    if (filter?.filterField === "make_id") {
      return options?.filter((option) =>
        option.name.toLowerCase().includes(searchValue.toLowerCase())
      );
    }

    if (filter?.filterField === "model_id") {
      const filteredOptions = [];

      options.forEach((option) => {
        const subFilteredOptions = option.values.filter((subOption) => {
          return subOption.name
            .toLowerCase()
            .includes(searchValue.toLowerCase());
        });

        if (subFilteredOptions.length)
          filteredOptions.push({ ...option, values: subFilteredOptions });
      });
      return filteredOptions;
    }
  };

  useEffect(() => {
    if (!openedFilter) setSearchValue("");
  }, [openedFilter]);

  const renderer = () => {
    if (searchable && options?.length > 0 && filter?.filterField === "make_id") {
      return (
        <>
          <div className={stl.textBoxContainer}>
            <img
              src={CDN_LINK + "/assets/images/textsearch.svg"}
              alt="search"
            />
            <input
              type="text"
              placeholder={t("ابحث عن الماركة", { ns: "web_search" })}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>

          {filteredOptions()?.map((option, i) => {
            const isChecked = tempSelectedOptions?.some((item) => {
              return item.id === option.id && item?.filterField === fieldName;
            });

            const countInSelected = selectedOptions?.find(
              (selectedOption) => selectedOption.id === option.id
            )?.count;

            return (
              <CheckBox
                filterType={filterType}
                disabled={option.count == 0 && !isChecked}
                count={countInSelected || option.count}
                key={option.id}
                name={name}
                label={option.name}
                value={option.id}
                onChange={onChange}
                logo={option.icon_url}
                alt={option.altName}
                fieldName={fieldName}
                checked={isChecked}
                carshape={carshape}
                carShapeImage={option.icon_url}
                carType={option.name}
                // all related to car shape checkobox
                isColorFilter={isColorFilter}
                color={option.hex_code || ""}
                isColor={isColor}
                isWhite={option.id === 1 || option.id === 9 || option.id === 8}
                filter={filter}
                option={option}
              />
            );
          })}
        </>
      );
    }
    if (
      searchable &&
      options?.length > 0 &&
      filter?.filterField === "model_id"
    ) {
      return (
        <>
          <div className={stl.textBoxContainer}>
            <img
              src={CDN_LINK + "/assets/images/textsearch.svg"}
              alt="search"
            />
            <input
              type="text"
              placeholder={t("ابحث عن الماركة", { ns: "web_search" })}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>

          {filteredOptions()?.map((option, i) => {
            const isChecked = tempSelectedOptions?.some((item) => {
              return item.id === option.id && item?.filterField === fieldName;
            });

            return (
              <React.Fragment key={i + "subIndex"}>
                <div className={stl.groupContainer}>
                  <div className={stl.subGroupHeading}>
                    {option.icon_url && !option.modelName && (
                      <div className={stl.carLogo}>
                        <img src={option.icon_url} alt={option.altName} />
                      </div>
                    )}
                    <span
                      className={
                        isBoldGropuTitle ? stl.isBoldGropuTitle : undefined
                      }
                    >
                      {option.name}
                    </span>
                    <span
                      className={
                        isBoldGropuTitle ? stl.isBoldGropuTitle : undefined
                      }
                    >
                      {option.modelName}
                    </span>
                  </div>
                  <div className={stl.makesContainer}>
                    {option.values?.map((subOpt, idx) => {
                      const isChecked = tempSelectedOptions?.some((item) => {
                        return (
                          item.id === subOpt.id &&
                          item?.filterField === fieldName
                        );
                      });

                      const countInSelected = selectedOptions?.find(
                        (selectedOption) => selectedOption.id === subOpt.id
                      )?.count;

                      return (
                        <CheckBox
                          filterType={filterType}
                          disabled={
                            subOpt.count == 0 && !isChecked ? true : false
                          }
                          modelId={option.modelId}
                          makeId={option.id}
                          fieldName={fieldName}
                          key={idx + "carSubModel"}
                          name={name}
                          count={countInSelected || subOpt.count}
                          option={subOpt}
                          label={subOpt.name}
                          value={subOpt.id}
                          onChange={onChange}
                          checked={isChecked}
                          filter={filter}
                        />
                      );
                    })}
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </>
      );
    }

    return options?.map((option, i) => {
      const isChecked = tempSelectedOptions?.some((item) => {
        return item.id === option.id && item?.filterField === fieldName;
      });

      const countInSelected = selectedOptions?.find(
        (selectedOption) => selectedOption.id === option.id
      )?.count;

      if (hasSubGroups) {
        return (
          <React.Fragment key={i + "subIndex"}>
            <div className={stl.groupContainer}>
              <div className={stl.subGroupHeading}>
                {option.icon_url && !option.modelName && (
                  <div className={stl.carLogo}>
                    <img src={option.icon_url} alt={option.altName} />
                  </div>
                )}
                <span
                  className={
                    isBoldGropuTitle ? stl.isBoldGropuTitle : undefined
                  }
                >
                  {option.name}
                </span>
                <span
                  className={
                    isBoldGropuTitle ? stl.isBoldGropuTitle : undefined
                  }
                >
                  {option.modelName}
                </span>
              </div>
              <div className={stl.makesContainer}>
                {option.values?.map((subOpt, idx) => {
                  const isChecked = tempSelectedOptions?.some((item) => {
                    return (
                      item.id === subOpt.id && item?.filterField === fieldName
                    );
                  });

                  const countInSelected = selectedOptions?.find(
                    (selectedOption) => selectedOption.id === subOpt.id
                  )?.count;

                  return (
                    <CheckBox
                      filterType={filterType}
                      disabled={subOpt.count == 0 && !isChecked ? true : false}
                      modelId={option.modelId}
                      makeId={option.id}
                      fieldName={fieldName}
                      key={idx + "carSubModel"}
                      name={name}
                      count={countInSelected || subOpt.count}
                      option={subOpt}
                      label={subOpt.name}
                      value={subOpt.id}
                      onChange={onChange}
                      checked={isChecked}
                      filter={filter}
                    />
                  );
                })}
              </div>
            </div>
          </React.Fragment>
        );
      }

      return (
        <CheckBox
          // all related to car shape checkobox
          filterType={filterType}
          disabled={false}
          fieldName={fieldName}
          carshape={carshape}
          carShapeImage={option.icon_url}
          carType={option.name}
          // all related to car shape checkobox
          isColorFilter={isColorFilter}
          key={option.id}
          name={name}
          option={option}
          label={option.name}
          value={option.id}
          onChange={onChange}
          count={countInSelected || option.count}
          checked={isChecked}
          color={option.hex_code || ""}
          isColor={isColor}
          isWhite={option.id === 1 || option.id === 9}
          filter={filter}
        />
      );
    });
  };

  return (
    <>
      <div
        className={[
          stl.container,
          carshape ? [stl.noPadding, stl.shapContainer].join(" ") : undefined,
        ].join(" ")}
      >
        {renderer()}
      </div>
      <div className={stl.noteContainer}>
        <p>
          <strong>{t("حاول إزالة بعض الفلاتر", { ns: "web_search" })}</strong>{" "}
          <span>{t("لإيجاد نتائج بحث مطابقة", { ns: "web_search" })}</span>
        </p>
        <button onClick={handleCloseFilter}>
          {t("العودة لفلترة النتائج", { ns: "web_search" })}
        </button>
      </div>
    </>
  );
};

export default CheckBoxGroup;
